import React, { useState } from 'react';
import PhoneNumberInput from '../components/Login/PhoneNumberInput';
import OtpVerification from '../components/Login/OtpVerification';
import PasswordLogin from '../components/Login/PasswordLogin';


function LoginScreen() {
  const [step, setStep] = useState(3);
  const [phoneNumber, setPhoneNumber] = useState('');

  const handleContinue = (phoneNumber) => {
    setPhoneNumber(phoneNumber);
    setStep(2);
  };

  const handleVerify = (otp) => {
    console.log(`Verifying OTP: ${otp}`);
    // Add verification logic here
  };

  const handleSteps = () =>{
    setStep(3);
  }

  const handleLogin = (credentials) => {
    console.log('Logging in with:', credentials);
    // Add login logic here
  };

  return (
    <div className="center-container">
      {/* {step === 1 && <PhoneNumberInput onContinue={handleContinue} handleSteps={handleSteps}/>}
      {step === 2 && <OtpVerification phoneNumber={phoneNumber} onVerify={handleVerify} handleSteps={handleSteps} />} */}
      {step === 3 && <PasswordLogin onLogin={handleLogin} />}
    </div>
  );
}

export default LoginScreen;
